import { render, staticRenderFns } from "./Craft.vue?vue&type=template&id=73600936&scoped=true&"
import script from "./Craft.vue?vue&type=script&lang=js&"
export * from "./Craft.vue?vue&type=script&lang=js&"
import style0 from "./Craft.vue?vue&type=style&index=0&id=73600936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73600936",
  null
  
)

export default component.exports